"use client";

import React from "react";
import { Icon } from "@iconify/react";
import { Image } from "@heroui/react";
import { useTranslation } from "react-i18next";
import { useBrand } from "@webuild-ai/react-auth";

export interface PageTitleProps {
  title: string;
  icon?: string;
  img?: string;
  subtitle?: string;
  dataId?: string;
  centered?: boolean;
}

export const PageTitle: React.FC<PageTitleProps> = ({
  title,
  icon,
  img,
  subtitle,
  dataId,
  centered = false,
}) => {
  const { t } = useTranslation();
  const { brand } = useBrand();

  const showImage = brand.menuItemsIcon === "image" && img;
  // Centre on mobile by default, respect `centered` prop on larger screens
  const containerClass = centered
    ? "flex flex-col gap-2 mb-4 items-center"
    : "mb-6 flex flex-col items-center md:items-start";
  const titleRowClass = centered
    ? "flex items-center gap-3 justify-center"
    : "flex items-center gap-3 justify-center md:justify-start";

  return (
    <div className={containerClass}>
      <div className={titleRowClass} data-id={dataId}>
        {icon &&
          (showImage ? (
            <Image height={32} radius="none" src={img} width={32} />
          ) : (
            <Icon className="text-primary" height={32} icon={icon} width={32} />
          ))}
        <h1 className="text-xl md:text-2xl font-bold">{t(title)}</h1>
      </div>
      {subtitle && (
        <p
          className={`text-sm text-default-500 ${centered ? "text-center" : "mt-2 text-center md:text-left"}`}
        >
          {t(subtitle)}
        </p>
      )}
    </div>
  );
};
